import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';

export default action('removeMentionTuple')(function removeMentionTuple(
    viewState: AtMentionsViewState,
    atMentionId: string,
    targetRecipient: FindRecipientPersonaType
) {
    viewState.atMentionTuples[atMentionId] = targetRecipient;
});
